import { createAsyncThunk } from "@reduxjs/toolkit";

import { getAnonymousUserToken } from "@/models";
import { AppState } from "@/redux/store/store";

export const fetchAnonymousUser = createAsyncThunk(
  "anonymousUser/fetchAnonymousUser",
  async (
    params: Partial<{ config: object }>,
    { getState, rejectWithValue }
  ) => {
    try {
      const { config } = params;
      const { adapter } = getState() as AppState;
      const { token } = await getAnonymousUserToken(
        adapter.adapter.baseUrl,
        config
      );
      return token;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
